
import FF_Module from './FF_Module'; // eslint-disable-line no-autofix/snakecasejs/snakecasejs

/**
 * Module qui créé une grille Macy pour les éléments ".macy-grid".
 */
export default class FF_Macy_Grid extends FF_Module {
  init() {
    this.macy = Macy({
      container: this.elements.container,
      columns  : 2,
      margin   : 0,
      breakAt  : {
        749: {
          columns: 1
        }
      }
    });
  }
}
